export const paths = {
  process: '/api/customer-portal/reconciliators/process',
  getListConciliator: '/api/customer-portal/reconciliators',
  getServiceInfo: '/faturamento/get_serviceInfo',
  getReconciliationsHistory: '/api/customer-portal/reconciliators/history',
};